// Auto-generated TypeScript types for resteasytox
// Based on Java models from com.reqo.timetracker.model

export class Employee {
	id: number;
	employeeType: number;
	firstName: string;
	lastName: string;
	loginName: string;
	password: string;
	qbName: string;
	email: string;
	startWorkTime: string;
	finishWorkTime: string;
	paymentFrequency: string;
	color: string;
	disabled: boolean;
	admin: boolean;
	qbAdmin: boolean;
	ttAdmin: boolean;
	timeAdmin: boolean;
	settingsBitmask: number;
	startWork: number;
	finishWork: number;
	accessKey: string;

	constructor();
	constructor(_id?: number, _employeeType?: number, _firstName?: string, _lastName?: string, _loginName?: string, _password?: string, _qbName?: string, _email?: string, _startWorkTime?: string, _finishWorkTime?: string, _paymentFrequency?: string, _color?: string, _disabled?: boolean, _admin?: boolean, _qbAdmin?: boolean, _ttAdmin?: boolean, _timeAdmin?: boolean, _settingsBitmask?: number, _startWork?: number, _finishWork?: number, _accessKey?: string);
	constructor(_id?: number, _employeeType?: number, _firstName?: string, _lastName?: string, _loginName?: string, _password?: string, _qbName?: string, _email?: string, _startWorkTime?: string, _finishWorkTime?: string, _paymentFrequency?: string, _color?: string, _disabled?: boolean, _admin?: boolean, _qbAdmin?: boolean, _ttAdmin?: boolean, _timeAdmin?: boolean, _settingsBitmask?: number, _startWork?: number, _finishWork?: number, _accessKey?: string) {
	    this.id = _id;
	    this.employeeType = _employeeType;
	    this.firstName = _firstName;
	    this.lastName = _lastName;
	    this.loginName = _loginName;
	    this.password = _password;
	    this.qbName = _qbName;
	    this.email = _email;
	    this.startWorkTime = _startWorkTime;
	    this.finishWorkTime = _finishWorkTime;
	    this.paymentFrequency = _paymentFrequency;
	    this.color = _color;
	    this.disabled = _disabled;
	    this.admin = _admin;
	    this.qbAdmin = _qbAdmin;
	    this.ttAdmin = _ttAdmin;
	    this.timeAdmin = _timeAdmin;
	    this.settingsBitmask = _settingsBitmask;
	    this.startWork = _startWork;
	    this.finishWork = _finishWork;
	    this.accessKey = _accessKey;
	}

	public initFromJson(jsonData: string): Employee {
	    const data = JSON.parse(jsonData);
	    return this.initFromData(data);
	}

	public initFromData(data: any): Employee {
	    Object.assign(this, data);
	    return this;
	}

	public toJson(dontEncode?: boolean): string {
	    return JSON.stringify(this);
	}
}

export class EmployeeEditHistoryEntry {
	id: number;
	startDate: number;
	employeeId: number;
	endDate: number;
	employeeType: number;
	payFrequency: string;
	quickBookName: string;
	workStartTime: number;
	workEndTime: number;
	startDateFormatted: string;
	endDateFormatted: string;

	constructor();
	constructor(_id?: number, _startDate?: number, _employeeId?: number, _endDate?: number, _employeeType?: number, _payFrequency?: string, _quickBookName?: string, _workStartTime?: number, _workEndTime?: number, _startDateFormatted?: string, _endDateFormatted?: string);
	constructor(_id?: number, _startDate?: number, _employeeId?: number, _endDate?: number, _employeeType?: number, _payFrequency?: string, _quickBookName?: string, _workStartTime?: number, _workEndTime?: number, _startDateFormatted?: string, _endDateFormatted?: string) {
	    this.id = _id;
	    this.startDate = _startDate;
	    this.employeeId = _employeeId;
	    this.endDate = _endDate;
	    this.employeeType = _employeeType;
	    this.payFrequency = _payFrequency;
	    this.quickBookName = _quickBookName;
	    this.workStartTime = _workStartTime;
	    this.workEndTime = _workEndTime;
	    this.startDateFormatted = _startDateFormatted;
	    this.endDateFormatted = _endDateFormatted;
	}

	public initFromJson(jsonData: string): EmployeeEditHistoryEntry {
	    const data = JSON.parse(jsonData);
	    return this.initFromData(data);
	}

	public initFromData(data: any): EmployeeEditHistoryEntry {
	    Object.assign(this, data);
	    return this;
	}

	public toJson(dontEncode?: boolean): string {
	    return JSON.stringify(this);
	}
}

export class Timecard {
	id: number;
	startDateRange: number;
	endDateRange: number;
	sequenceId: string;
	waitApproval: boolean;
	transactionId: string;
	createdDate: number;
	employee: Employee;
	billingUnitsTotal: number;

	constructor();
	constructor(_id?: number, _startDateRange?: number, _endDateRange?: number, _sequenceId?: string, _waitApproval?: boolean, _transactionId?: string, _createdDate?: number, _employee?: Employee, _billingUnitsTotal?: number);
	constructor(_id?: number, _startDateRange?: number, _endDateRange?: number, _sequenceId?: string, _waitApproval?: boolean, _transactionId?: string, _createdDate?: number, _employee?: Employee, _billingUnitsTotal?: number) {
	    this.id = _id;
	    this.startDateRange = _startDateRange;
	    this.endDateRange = _endDateRange;
	    this.sequenceId = _sequenceId;
	    this.waitApproval = _waitApproval;
	    this.transactionId = _transactionId;
	    this.createdDate = _createdDate;
	    this.employee = _employee;
	    this.billingUnitsTotal = _billingUnitsTotal;
	}

	public initFromJson(jsonData: string): Timecard {
	    const data = JSON.parse(jsonData);
	    return this.initFromData(data);
	}

	public initFromData(data: any): Timecard {
	    Object.assign(this, data);
	    return this;
	}

	public toJson(dontEncode?: boolean): string {
	    return JSON.stringify(this);
	}
}

export class TimecardRow {
	id: number;
	date: number;
	employee: Employee;
	timecard: Timecard;
	note: string;
	billingUnits: number;
	billableHours: number;
	nonBillableHours: number;

	constructor();
	constructor(_id?: number, _date?: number, _employee?: Employee, _timecard?: Timecard, _note?: string, _billingUnits?: number, _billableHours?: number, _nonBillableHours?: number);
	constructor(_id?: number, _date?: number, _employee?: Employee, _timecard?: Timecard, _note?: string, _billingUnits?: number, _billableHours?: number, _nonBillableHours?: number) {
	    this.id = _id;
	    this.date = _date;
	    this.employee = _employee;
	    this.timecard = _timecard;
	    this.note = _note;
	    this.billingUnits = _billingUnits;
	    this.billableHours = _billableHours;
	    this.nonBillableHours = _nonBillableHours;
	}

	public initFromJson(jsonData: string): TimecardRow {
	    const data = JSON.parse(jsonData);
	    return this.initFromData(data);
	}

	public initFromData(data: any): TimecardRow {
	    Object.assign(this, data);
	    return this;
	}

	public toJson(dontEncode?: boolean): string {
	    return JSON.stringify(this);
	}
}

export class Client {
	private baseUrl: string;
	public withCredentials: boolean = true;

	constructor(baseUrl: string = '') {
	    this.baseUrl = baseUrl;
	}

	public getBaseUrl(): string {
	    return this.baseUrl;
	}

	public setBaseUrl(baseUrl: string): void {
	    this.baseUrl = baseUrl;
	}
}

export class SettingResource {
	private client: Client;

	constructor(client: Client) {
	    this.client = client;
	}
}

export class EmployeeEditHistoryResource {
	private client: Client;

	constructor(client: Client) {
	    this.client = client;
	}

	public put(entry: EmployeeEditHistoryEntry): Promise<any> {
	    return fetch(this.client.getBaseUrl() + 'employeeEditHistory/put', {
	        method: 'POST',
	        credentials: 'include',
	        headers: { 'Content-Type': 'application/json' },
	        body: entry.toJson()
	    }).then((response: Response) => {
	        if (!response.ok) {
	            return Promise.reject(response);
	        }
	        return response.json();
	    });
	}

	public delete(id: number): Promise<any> {
	    return fetch(this.client.getBaseUrl() + 'employeeEditHistory/delete/' + id, {
	        method: 'DELETE',
	        credentials: 'include'
	    }).then((response: Response) => {
	        if (!response.ok) {
	            return Promise.reject(response);
	        }
	        return response.json();
	    });
	}

	public getAll(): Promise<EmployeeEditHistoryEntry[]> {
	    return Promise.resolve([]);
	}
}




// WEBPACK FOOTER //
// ./vendor/resteasytox/index.ts